import { wsdButtonDefaultProps } from 'src/wsd/components/Button/wsdButtonDefaultProps';

export const wsdButtonGroupDefaultProps = wsdButtonDefaultProps;
